












import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
  import { FetchState, Transaction } from "@/shared/types";
  import TransactionListItem from "@/shared/components/ui/TransactionListItem.vue";
  import Widget from "@/shared/components/Widget.vue";
  import Button from "@/shared/components/ui/Button.vue";
  import _ from "lodash";
import { useHsaStore } from "@/shared/store/hsa";
import { useHsaTotalStore } from "@/shared/store/hsaTotal";
import { useHsaPendingTransactionStore } from "@/shared/store/hsaPendingTransaction";
  @Component ({
    components: {
      Widget,
      TransactionListItem,
      Button
    }
  })
  export default class RecentContributions extends Vue {
    pendingTransactionStore = useHsaPendingTransactionStore();
    hsaStore = useHsaStore();
    hsaTotalStore = useHsaTotalStore();

    @Prop() numberOfRecords: number;

    mounted () {
      this.pendingTransactionStore.fetchContributionActivity();
      this.hsaStore.loadHsaContributionsDictionary({
        pageNumber: 1
      });
      this.hsaTotalStore.getUserPayrollSummary();

      // if numberOfRecords is not definied set it to previous default value:3
      this.numberOfRecords = this.numberOfRecords === undefined ? 3 : this.numberOfRecords;
    }

    get combinedContributionActivity () {
      return _.orderBy(this.pendingTransactionStore.contributionActivity
        .concat(this.hsaStore.contributionsForCurrentPage)
        .concat(this.upcomingContributions), ["postedDate"], ["desc"])
      .slice(0, this.numberOfRecords);
    }

    get upcomingContributions (): Transaction[] {
      const transactions: Transaction[] = [];

      if (this.hsaTotalStore.nextPayrollFunding && this.hsaTotalStore.nextPayrollFunding.employeeRecurringAmount) {
        transactions.push({
          postedDate: this.hsaTotalStore.nextPayrollFunding.payrollDate,
          source: null,
          displaySource: "Employee Payroll",
          description: "Employee Payroll",
          amount: this.hsaTotalStore.nextPayrollFunding.employeeRecurringAmount,
          moneyIncreasing: true,
          displayDescription: "Pay Period Contribution",
          status: null,
          displayStatus: "Upcoming",
          linkedBankAccount: null
        });
      }

      if (this.hsaTotalStore.nextPayrollFunding && this.hsaTotalStore.nextPayrollFunding.employerAmount) {
        transactions.push({
          postedDate: this.hsaTotalStore.nextPayrollFunding.payrollDate,
          source: null,
          displaySource: "Employer Payroll",
          description: "Employer Payroll",
          amount: this.hsaTotalStore.nextPayrollFunding.employerAmount,
          moneyIncreasing: true,
          displayDescription: "Pay Period Contribution",
          status: null,
          displayStatus: "Upcoming",
          linkedBankAccount: null
        });
      }

      if (this.hsaTotalStore.nextPayrollFunding && this.hsaTotalStore.nextPayrollFunding.employeeOneTimeAmount) {
        transactions.push({
          postedDate: this.hsaTotalStore.nextPayrollFunding.payrollDate,
          source: null,
          displaySource: "One-Time Lift",
          description: "One-Time Lift",
          amount: this.hsaTotalStore.nextPayrollFunding.employeeOneTimeAmount,
          moneyIncreasing: true,
          displayDescription: "Pay Period Contribution",
          status: null,
          displayStatus: "Upcoming",
          linkedBankAccount: null
        });
      }

      return transactions;
    }

    get displayContributions (): boolean {
      return this.isLoaded && !!this.combinedContributionActivity.length;
    }

    get isLoaded () {
      return this.hsaStore.fetchState === FetchState.Loaded
        && this.pendingTransactionStore.contributionActivityIsLoaded
        && this.hsaTotalStore.userPayrollSummaryIsLoaded;
    }

  }
